import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Hidden from "@mui/material/Hidden";
import { YSButton } from "../../uikit/YSButton";
import DRxInput from "../../uikit/DRxInput";
import React, { useRef, useState } from "react";
import { ErrorMessage, Form, Formik } from "formik";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import * as yup from "yup";
import {
  warnColor,
  InputSMBoxStyle,
  DatePickerField,
  BtnSMGroupStyle,
  ContentStyle,
  DRxInputStyle,
  DRxSelectStyle,
  TelephoneStyle,
  ScrollBarStyle,
  lightGreyColor,
} from "../../Theme";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import DRxSelect from "../../uikit/DRxSelect";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import { consentTypes, countryOptions } from "../../components/Content";
import { DRxSelect2 } from "../../uikit/DRxSelect2";
import { useSelector } from "react-redux";
import {
  ClinicDetails,
  PatientRegistrationAPI,
} from "../../Apis/AuthApiServices";
import { DialogPopup } from "../../components/DialogPopup";
import YSSnackBar from "../../uikit/YSSnackBar";
import { useNavigate } from "react-router";
import { YSSelectSearch } from "../../uikit/YSSelectSearch";
import useFetch from "../../CustomHooks/useFetch";
import { getRxExperienceEntryPath } from "../../utils/AIPrescription/rxExperiencePreference";

export default function Registration() {
  const home2Ref = useRef<any>(null);
  const home3Ref = useRef<any>(null);
  const work2Ref = useRef<any>(null);
  const work3Ref = useRef<any>(null);
  const AllDropdwonsState = useSelector((state: any) => {
    return { ...state.GlobalDropdownSlice.DropdownLists };
  }); //redux data
  const PrescriberDetailsState = useSelector((state: any) => {
    return { ...state?.PrescriberDetailsSlice?.AllPrescriberDetails };
  }); //redux data
  const navigate = useNavigate();
  const [registerPopUP, setregisterPopUP] = useState(false);
  const handleShowApprovedPopupClick = () => {
    setregisterPopUP(true);
  };
  const handleHideApprovedPopupClick = () => {
    setregisterPopUP(false);
  };
  const [registerStateData, setRegisterStateData] = useState<any>({});
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const handleSubmitPatientRegistration = async (
    values: any,
    resetForm: any
  ) => {
    try {
      const doctorId = localStorage.getItem("doctorId");
      const BodyData = {
        doctorId: doctorId,
        telHomeCode: values.telHomeCode ?? "",
        telHomeNo1: values.telHomeNo1 ?? "",
        telHomeNo2: values.telHomeNo2 ?? "",
        telWorkCode: values.telWorkCode ?? "",
        telWorkNo1: values.telWorkNo1 ?? "",
        telWorkNo2: values.telWorkNo2 ?? "",
        firstName: values.FirstName ?? "",
        middleName: values.MiddleName ?? "",
        lastName: values.LastName ?? "",
        gender: values.Gender !== "Select" ? values.Gender : "" ?? "",
        prefix: values.Prefix ?? "",
        suffix: values.Suffix ?? "",
        dateOfBirth: values.DateOfBirth ?? "",
        height: values.Height ?? "",
        weight: values.Weight ?? "",
        email: values.Email ?? "",
        address1: values.Address ?? "",
        address2: values.Address2 ?? "",
        city: values.City ?? "",
        state: values.State !== "Select State" ? values.State : "",
        country: values.Country ?? "",
        zip: values.Zip ?? "",
        consent: values.Consent ?? "",
        detailedPersonDTO: null,
        noActiveMedsReported: false,
        confirmEmail: values.ConfirmEmail ?? "",
      };

      const result = await PatientRegistrationAPI(BodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setRegisterStateData(result?.data?.response[0]);
        resetForm();
        handleShowApprovedPopupClick();
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "try again After Some time !",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const Params = {
    doctorId: localStorage.getItem("doctorId"),
    pageNumber: 0,
    pagination: "none",
  };
  const { data }: any = useFetch(Params, ClinicDetails, []);
  let selectedClinicData = data[0]?.items?.filter(
    (item: any) =>
      item?.personAddressId === PrescriberDetailsState?.selectedAddress
  );
  let selectedState;
  if (selectedClinicData) {
    selectedState = AllDropdwonsState?.statesOptions?.filter(
      (each: any) => each?.value === selectedClinicData[0]?.state
    );
  }
  const [selectedDate, setSelectedDate] = useState<any>("");

  const handleDateChange = (date: any) => {
    // console.log("date", date);
    setSelectedDate(date);
  };
  const calculateAge = (dob: any) => {
    const dateOfBirth = moment(dob, "MM/DD/YYYY");
    const age = moment().diff(dateOfBirth, "years");
    return age;
  };
  return (
    <>
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          Patient Registration
          <HelpGuideTooltip
            content={
              <>
                {" "}
                <Typography component="div" variant="body1">
                  The patient registration form provided to prescribers to
                  register new patients
                </Typography>
              </>
            }
          />
        </Typography>
        <Formik
          initialValues={{
            FirstName: "",
            LastName: "",
            MiddleName: "",
            Prefix: "",
            Suffix: "",
            Gender: "Select",
            DateOfBirth: "",
            Address: "",
            Address2: "",
            City: "",
            State: selectedState
              ? selectedState[0]?.value
              : "Select State" ?? "",
            telHomeCode: "",
            telHomeNo1: "",
            telHomeNo2: "",
            telWorkCode: "",
            telWorkNo1: "",
            telWorkNo2: "",
            Zip: "",
            Country: "US",
            Email: "",
            ConfirmEmail: "",
            Consent: "",
            Weight: "",
            Height: "",
            StateName: selectedState
              ? selectedState[0]?.label
              : "Select State" ?? "",
          }}
          validationSchema={yup.object().shape({
            FirstName: yup
              .string()
              .matches(
                /^[a-zA-Z!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/? ]*$/,
                "First name should be alphabetic characters."
              )
              .required("First name is required")
              .max(32)
              .min(1),
            LastName: yup
              .string()
              .matches(
                /^[a-zA-Z!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/? ]*$/,
                "Last name should be alphabetic characters."
              )
              .required("Last name is required")
              .max(32)
              .min(1),
            MiddleName: yup.string().min(0).max(16),
            Address: yup.string().required("Address is required"),
            StateName: yup.string().required("State is required"),
            City: yup.string().required("City is required"),
            DateOfBirth: yup
              .date()
              .nullable()
              .required("Date of Birth is required")
              .typeError("Date of Birth is required"),
            Height: yup
              .string()
              .nullable()
              .when("DateOfBirth", {
                is: (val: any) => calculateAge(val) >= 18,
                then: yup.string().notRequired().nullable(),
                otherwise: yup
                  .string()
                  .required("Height is required")
                  .nullable(),
              })
              .matches(/^[0-9]+$/, "Height should be in number."),
            Weight: yup
              .string()
              .nullable()
              .when("DateOfBirth", {
                is: (val: any) => calculateAge(val) >= 18,
                then: yup.string().notRequired().nullable(),
                otherwise: yup
                  .string()
                  .required("Weight is required")
                  .nullable(),
              })
              .matches(/^[0-9]+$/, "Weight should be in number."),
            Gender: yup.string().required("Gender is required"),
            Zip: yup
              .string()
              .required("Zip is required")
              .min(5)
              .max(5)
              .matches(/^[0-9]+$/, "Invalid zip."),
            Email: yup.string(),
            ConfirmEmail: yup.string().when("Email", {
              is: (val: any) => !!val,
              then: yup.string().required("Confirm email is required"),
              otherwise: yup.string().notRequired(),
            }),
          })}
          enableReinitialize
          onSubmit={(values, { resetForm }) => {
            handleSubmitPatientRegistration(values, resetForm);
          }}
        >
          {(registerProps) => (
            <Form onSubmit={registerProps.handleSubmit}>
              <Grid
                container
                item
                xs={12}
                spacing={0}
                alignItems="top"
                justifyContent="space-between"
                columnSpacing={2}
              >
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="lastname"
                    >
                      Last Name
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        <DRxInput
                          id="lastname"
                          name="LastName"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.LastName}
                          onChange={registerProps.handleChange}
                          onBlur={registerProps.handleBlur}
                          error={
                            registerProps.touched.LastName &&
                            Boolean(registerProps.errors.LastName)
                          }
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="middlename"
                      className="mr"
                    >
                      Middle Name
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        <DRxInput
                          id="middlename"
                          name="MiddleName"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.MiddleName}
                          onChange={registerProps.handleChange}
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="firstname"
                    >
                      First Name
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>
                    <Box>
                      <DRxInputStyle>
                        <DRxInput
                          id="firstname"
                          name="FirstName"
                          type="text"
                          className="input"
                          disabled={false}
                          value={registerProps.values.FirstName}
                          onChange={registerProps.handleChange}
                          onBlur={registerProps.handleBlur}
                          error={
                            registerProps.touched.FirstName &&
                            Boolean(registerProps.errors.FirstName)
                          }
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Hidden mdDown>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="prefix"
                        className="mr"
                      >
                        Prefix
                      </Typography>
                      <Box className="nested">
                        <DRxInputStyle>
                          <DRxInput
                            id="prefix"
                            name="Prefix"
                            type="text"
                            className=""
                            disabled={false}
                            onChange={registerProps.handleChange}
                            value={registerProps.values.Prefix}
                          />
                        </DRxInputStyle>
                        <Box className="nested">
                          <Typography
                            component="label"
                            variant="body2"
                            htmlFor="suffix"
                            className="mr suffix"
                          >
                            Suffix
                          </Typography>
                          <Box className="nested">
                            <DRxInputStyle>
                              <DRxInput
                                id="suffix"
                                name="Suffix"
                                type="text"
                                className=""
                                disabled={false}
                                value={registerProps.values.Suffix}
                                onChange={registerProps.handleChange}
                              />
                            </DRxInputStyle>
                            <Typography
                              component="div"
                              variant="body2"
                              className="info"
                            >
                              MD, PhD etc
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                </Hidden>
                <Hidden mdUp>
                  <Grid item xs={12}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="prefix"
                      >
                        Prefix
                      </Typography>
                      <Box>
                        <DRxInputStyle>
                          {" "}
                          <DRxInput
                            id="prefix"
                            name="Prefix"
                            type="text"
                            className=""
                            disabled={false}
                            onChange={registerProps.handleChange}
                            value={registerProps.values.Prefix}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="suffix"
                      >
                        Suffix
                      </Typography>
                      <Box>
                        <DRxInputStyle>
                          {" "}
                          <DRxInput
                            id="suffix"
                            name="Suffix"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.Suffix}
                            onChange={registerProps.handleChange}
                          />
                        </DRxInputStyle>
                        <Typography
                          component="div"
                          variant="body2"
                          className="info"
                        >
                          MD, PhD etc
                        </Typography>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                </Hidden>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="gender"
                    >
                      Gender
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>
                    <Box>
                      <DRxSelectStyle>
                        <DRxSelect
                          name="Gender"
                          id="gender"
                          data={
                            AllDropdwonsState?.genderOtions ?? [
                              { label: "", value: "" },
                            ]
                          }
                        />
                      </DRxSelectStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="dateofB"
                      className="mr"
                    >
                      Date of Birth
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>

                    <Box>
                      <DatePickerField>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            inputFormat="MM/dd/yyyy"
                            value={
                              selectedDate
                              // registerProps.values.DateOfBirth === ""
                              //   ? null
                              //   : registerProps.values.DateOfBirth
                            }
                            onChange={(e) => {
                              if (e === null) {
                                registerProps.setFieldValue("DateOfBirth", "");
                              } else {
                                registerProps.setFieldValue(
                                  "DateOfBirth",
                                  moment(e).format("MM/DD/yyyy")
                                );
                                handleDateChange(e);
                              }
                            }}
                            renderInput={(params) => (
                              <>
                                <TextField
                                  {...params}
                                  name="DateOfBirth"
                                  error={
                                    registerProps.touched.DateOfBirth &&
                                    Boolean(registerProps.errors.DateOfBirth)
                                  }
                                />
                                <Typography
                                  color="error"
                                  className="error"
                                  variant="body2"
                                  component="div"
                                >
                                  <ErrorMessage name="DateOfBirth" />
                                </Typography>
                              </>
                            )}
                          />
                        </LocalizationProvider>
                      </DatePickerField>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="address"
                    >
                      Address
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        <DRxInput id="address" name="Address" type="text" />
                      </DRxInputStyle>
                      <DRxInputStyle marginTop={1}>
                        <DRxInput id="address" name="Address2" type="text" />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="country"
                      className="mr"
                    >
                      Country
                    </Typography>
                    <Box>
                      <DRxSelectStyle>
                        <DRxSelect2
                          name="Country"
                          id="country"
                          options={countryOptions}
                          onChange={(option: any, e: any) => {
                            registerProps.setFieldValue(
                              "Country",
                              e.props.value
                            );
                          }}
                          value={registerProps.values.Country}
                        />
                      </DRxSelectStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="state"
                    >
                      State
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>
                    <Box>
                      <DRxSelectStyle>
                        <YSSelectSearch
                          id="state"
                          options={
                            AllDropdwonsState?.statesOptions ?? [
                              { label: "", value: "" },
                            ]
                          }
                          isOptionEqualToValue={(option: any, value: any) =>
                            option.label === value
                          }
                          name="StateName"
                          value={registerProps.values.StateName}
                          onChange={(event: any, value: any) => {
                            registerProps.setFieldValue("State", value.value);
                          }}
                          onInputChange={(option: any, e: any) => {
                            registerProps.setFieldValue("StateName", e);
                          }}
                          error={
                            registerProps.touched.StateName &&
                            Boolean(registerProps.errors.StateName)
                          }
                        />
                      </DRxSelectStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="city"
                      className="mr"
                    >
                      City
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        {" "}
                        <DRxInput
                          id="city"
                          name="City"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.City}
                          onChange={registerProps.handleChange}
                          onBlur={registerProps.handleBlur}
                          error={
                            registerProps.touched.City &&
                            Boolean(registerProps.errors.City)
                          }
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography component="label" variant="body2" htmlFor="zip">
                      Zip
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        {" "}
                        <DRxInput
                          id="zip"
                          name="Zip"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.Zip}
                          onChange={registerProps.handleChange}
                          onBlur={registerProps.handleBlur}
                          error={
                            registerProps.touched.Zip &&
                            Boolean(registerProps.errors.Zip)
                          }
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="email"
                      className="mr"
                    >
                      E-mail
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        {" "}
                        <DRxInput
                          id="email"
                          name="Email"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.Email}
                          onChange={registerProps.handleChange}
                          onBlur={registerProps.handleBlur}
                          error={
                            registerProps.touched.Email &&
                            Boolean(registerProps.errors.Email)
                          }
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="email"
                    >
                      Confirm E-mail
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        {" "}
                        <DRxInput
                          id="Cemail"
                          name="ConfirmEmail"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.ConfirmEmail}
                          onChange={registerProps.handleChange}
                          onBlur={registerProps.handleBlur}
                          error={
                            registerProps.touched.ConfirmEmail &&
                            Boolean(registerProps.errors.ConfirmEmail)
                          }
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="consent"
                      className="mr"
                    >
                      Consent
                    </Typography>
                    <Box>
                      <DRxSelectStyle>
                        <DRxSelect2
                          name="Consent"
                          id="consent"
                          options={consentTypes}
                          label="Consent"
                          onChange={(option: any, e: any) => {
                            registerProps.setFieldValue(
                              "Consent",
                              e.props.value
                            );
                          }}
                          value={registerProps.values.Consent}
                        />
                      </DRxSelectStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6} marginBottom={1}>
                  <InputSMBoxStyle>
                    <Typography component="label" variant="body2">
                      Telephone No.(Home)
                    </Typography>{" "}
                    <Box>
                      <TelephoneStyle>
                        <DRxInput
                          id="telephone"
                          name="telHomeCode"
                          type="number"
                          className=""
                          placeholder="Code"
                          onChange={(event: any) => {
                            registerProps.setFieldValue(
                              "telHomeCode",
                              event.target.value.slice(0, 3)
                            );
                            if (event.target.value.length === 3) {
                              home2Ref?.current?.focus();
                            }
                          }}
                        />{" "}
                        <DRxInput
                          id="telephone1"
                          name="telHomeNo1"
                          className=""
                          type="number"
                          placeholder="NO1"
                          inputRef={home2Ref}
                          onChange={(event: any) => {
                            registerProps.setFieldValue(
                              "telHomeNo1",
                              event.target.value.slice(0, 3)
                            );
                            if (event.target.value.length === 3) {
                              home3Ref?.current?.focus();
                            }
                          }}
                        />
                        <DRxInput
                          id="telephone2"
                          name="telHomeNo2"
                          className=""
                          type="number"
                          inputRef={home3Ref}
                          placeholder={"NO2"}
                          onChange={(event: any) => {
                            registerProps.setFieldValue(
                              "telHomeNo2",
                              event.target.value.slice(0, 4)
                            );
                          }}
                        />
                      </TelephoneStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6} marginBottom={1}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      className="mr"
                    >
                      Telephone No.(Work)
                    </Typography>{" "}
                    <Box>
                      <TelephoneStyle>
                        <DRxInput
                          id="telephoneWork"
                          name="telWorkCode"
                          type="number"
                          className=""
                          placeholder="Code"
                          onChange={(event: any) => {
                            registerProps.setFieldValue(
                              "telWorkCode",
                              event.target.value.slice(0, 3)
                            );
                            if (event.target.value.length === 3) {
                              work2Ref?.current?.focus();
                            }
                          }}
                        />{" "}
                        <DRxInput
                          id="telephoneWork2"
                          name="telWorkNo1"
                          type="number"
                          className=""
                          placeholder="NO1"
                          inputRef={work2Ref}
                          onChange={(event: any) => {
                            registerProps.setFieldValue(
                              "telWorkNo1",
                              event.target.value.slice(0, 3)
                            );
                            if (event.target.value.length === 3) {
                              work3Ref?.current?.focus();
                            }
                          }}
                        />
                        <DRxInput
                          id="telephoneWork2"
                          name="telWorkNo2"
                          type="number"
                          className=""
                          placeholder={"NO2"}
                          inputRef={work3Ref}
                          onChange={(event: any) => {
                            registerProps.setFieldValue(
                              "telWorkNo2",
                              event.target.value.slice(0, 4)
                            );
                          }}
                        />
                      </TelephoneStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="weight"
                    >
                      Weight (lbs(rounded))
                    </Typography>
                    <Box>
                      <DRxInputStyle>
                        {" "}
                        <DRxInput
                          id="weight"
                          name="Weight"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.Weight}
                          onChange={registerProps.handleChange}
                        />
                      </DRxInputStyle>
                      <Typography
                        component="div"
                        variant="body2"
                        className="info"
                      >
                        Enter Weight only in lbs(rounded), no text & special
                        characters allowed
                      </Typography>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="height"
                      className="mr"
                    >
                      Height (Inches)
                    </Typography>
                    <Box>
                      <DRxInputStyle>
                        {" "}
                        <DRxInput
                          id="height"
                          name="Height"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.Height}
                          onChange={registerProps.handleChange}
                        />
                      </DRxInputStyle>
                      <Typography
                        component="div"
                        variant="body2"
                        className="info mm"
                      >
                        Enter Height only in Inches, no text & special
                        characters allowed (ex:Enter 38 Inches if patient height
                        is 3feet 2inches)
                      </Typography>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                {/* <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="allergic"
                    >
                      Allergic To
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        {" "}
                        <DRxInput
                          id="allergic"
                          name="AllergicTo"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.AllergicTo}
                          onChange={registerProps.handleChange}
                          label={"Allergic To"}
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>{" "} */}
                <Grid item xs={12} md={6}></Grid>
                {/* <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="health"
                    >
                      Health Condition
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        {" "}
                        <DRxInput
                          id="health"
                          name="HealthCondition"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.HealthCondition}
                          onChange={registerProps.handleChange}
                          label={"Health Condition"}
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid> */}
                <Grid item xs={12} md={6} marginTop={5}>
                  <BtnSMGroupStyle>
                    <YSButton
                      size="large"
                      className=""
                      color="secondary"
                      dataTestId="submitBtn"
                      variant="outlined"
                      disabled={false}
                      type="reset"
                      children={"Reset"}
                      onClick={() => {
                        registerProps.resetForm();
                      }}
                    />
                    <YSButton
                      size="large"
                      className=""
                      color="primary"
                      dataTestId="submitBtn"
                      variant="contained"
                      disabled={false}
                      type="submit"
                      children={"Submit"}
                      onClick={null}
                    />
                  </BtnSMGroupStyle>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
        <DialogPopup
          windowsize={"sm"}
          show={registerPopUP}
          handleShowPopupClick={handleShowApprovedPopupClick}
          handleHidePopupClick={handleHideApprovedPopupClick}
        >
          <ScrollBarStyle
            className="h300"
            style={{
              margin: "25px auto",
              borderBottom: `1px solid ${lightGreyColor}`,
            }}
          >
            <Grid
              container
              item
              xs={12}
              spacing={1}
              alignItems="top"
              justifyContent="center"
            >
              <Grid item xs={12} textAlign={"center"}>
                <CheckCircleOutlineIcon
                  style={{ height: 70, width: 70 }}
                  color="success"
                />
              </Grid>
              <Grid item xs={12} textAlign={"center"}>
                <Typography
                  component="span"
                  variant="subtitle1"
                  fontWeight={600}
                >
                  {registerStateData?.message}
                </Typography>{" "}
              </Grid>
            </Grid>{" "}
          </ScrollBarStyle>
          <Grid
            container
            item
            xs={12}
            spacing={1}
            alignItems="top"
            justifyContent="center"
          >
            <Grid item xs={12} textAlign={"center"}>
              <YSButton
                children={"Go to RxPad"}
                onClick={() => {
                  navigate(getRxExperienceEntryPath(), { state: "fromRegistration" });
                  sessionStorage.setItem(
                    "patientId",
                    registerStateData?.patientId
                  );
                }}
                variant={"contained"}
                size={"large"}
              />
            </Grid>{" "}
          </Grid>{" "}
        </DialogPopup>
      </ContentStyle>

      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
